function sameCompany(issue, user) {
  const companyId = user && (user.company?.companyId ?? user.companyId);
  if (!issue || companyId == null) return false;
  return issue.companyId == null || String(issue.companyId) === String(companyId);
}

export function canEditIssue(issue, user) {
  return sameCompany(issue, user) && user.userId != null &&
    (Number(user.roleId) === 1 || (issue.recorderId != null && String(issue.recorderId) === String(user.userId)));
}

export function canDeleteIssue(issue, user) {
  return sameCompany(issue, user) && Number(user.roleId) === 1;
}
